import { useTranslation } from "react-i18next";
import { LANDING_FEATURES } from "../data/features";

export function FeaturesGrid() {
  const { t } = useTranslation("landing");

  return (
    <section
      id="features"
      className="scroll-mt-24 relative border-t border-[#1B2622]"
    >
      <div className="relative mx-auto max-w-[1320px] px-6 py-24 lg:px-10 lg:py-28">
        <div className="flex flex-col gap-8 border-b border-[#1B2622] pb-10 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <h2 className="bp-display text-[34px] text-[#E2EDE7] sm:text-[44px]">
              {t("features.title")}
            </h2>
          </div>
          <p className="max-w-[40ch] text-[15px] leading-[1.7] text-[#788A82]">
            {t("features.subtitle")}
          </p>
        </div>

        <ul className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {LANDING_FEATURES.map((f, idx) => {
            const Icon = f.icon;
            return (
              <li
                key={f.id}
                className="bp-panel group flex flex-col gap-6 p-7 anim-fade-up"
                style={{ animationDelay: `${120 + idx * 80}ms` }}
              >
                <div className="flex items-center justify-between">
                  <span className="inline-flex h-10 w-10 items-center justify-center border border-[#25332E] bg-[#070A0B] text-[#4CD6C4] transition-colors group-hover:border-[#4CD6C4]/60">
                    <Icon className="h-[18px] w-[18px]" aria-hidden />
                  </span>
                  <span className="bp-mono text-[12px] tracking-[0.1em] text-[#46554F] transition-colors group-hover:text-[#4CD6C4]">
                    {String(idx + 1).padStart(2, "0")}
                  </span>
                </div>
                <div>
                  <h3 className="bp-mono text-[15px] font-semibold uppercase tracking-[0.02em] text-[#E2EDE7]">
                    {t(f.titleKey)}
                  </h3>
                  <p className="mt-3 text-[14px] leading-[1.7] text-[#8A9990]">
                    {t(f.bodyKey)}
                  </p>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}

export default FeaturesGrid;
